import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLakeQuery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M7.032 5.971a.75.75 0 0 0-1.064 0q-.12.12-.243.249c-.305.312-.636.652-1.009.95-.485.389-.895.58-1.216.58a.75.75 0 0 0 0 1.5c.85 0 1.602-.467 2.153-.908.315-.252.612-.535.866-.79.303.269.663.563 1.059.827.662.443 1.52.871 2.422.871s1.76-.428 2.422-.87a10 10 0 0 0 1.059-.828c.254.255.551.538.866.79.551.44 1.302.908 2.153.908a.75.75 0 0 0 0-1.5c-.32 0-.73-.191-1.216-.58-.373-.298-.704-.638-1.009-.95l-.243-.249a.75.75 0 0 0-1.064 0 9.4 9.4 0 0 1-1.38 1.161c-.578.387-1.131.618-1.588.618s-1.01-.231-1.588-.618a9.4 9.4 0 0 1-1.38-1.161m0 6a.75.75 0 0 0-1.064 0q-.12.12-.243.249c-.305.312-.636.652-1.009.95-.485.389-.895.58-1.216.58a.75.75 0 0 0 0 1.5c.85 0 1.602-.467 2.153-.908.315-.252.612-.535.866-.79.303.269.663.563 1.059.827.662.443 1.52.871 2.422.871a.75.75 0 0 0 0-1.5c-.457 0-1.01-.231-1.588-.618a9.4 9.4 0 0 1-1.38-1.161" />
  </svg>
);
export default SvgLakeQuery;
